import styled from 'styled-components';

import { StoreFieldsFragment } from '../../graphql';

export type AddressProps = React.HTMLAttributes<HTMLDivElement> & {
	store: StoreFieldsFragment;
	lineProps?: React.HTMLAttributes<HTMLParagraphElement>;
};

const Line = styled.p`
	font-weight: 300;
`;

export const Address: React.FC<AddressProps> = ({
	store: { address1, address2, city, state, zipCode },
	lineProps = { className: 'mb-0' },
	className,
	...props
}) => {
	return (
		<div
			className={`text-small store-address${
				className ? ` ${className}` : ''
			}`}
			{...props}
		>
			<Line {...lineProps}>{address1}</Line>
			<Line {...lineProps}>{address2}</Line>

			<Line {...lineProps}>
				{city && (zipCode || state ? city + ', ' : city)}
				{state && (zipCode ? state + ', ' : state)}
				{zipCode}
			</Line>
		</div>
	);
};
